import ChartContainer from '@synergy/charts';
import Spinner from './Spinner';
import { Flex } from 'antd';

export const NewRenderChart = ({ chartdata, charttype, clickTooltipData, height, width, chartId, language, title, isFetching, props }) => {
    return (
        <>
            {
                !isFetching ?
                    <ChartContainer charttype={charttype} clickTooltipData={clickTooltipData} height={height} width={width} chartData={chartdata} chartId={chartId} language={language} title={title} props={props} />
                    : 
                    <Flex justify="center" align='center' style={{height: height}}>
                        <Spinner stroke="green" size="42px" />
                    </Flex>
            }
        </>
    )
}